import React, {useState} from 'react';
import {Box, Stepper, Step, StepLabel, Button, Stack, Typography, Collapse , ImageList, ImageListItem} from '@mui/material';
import NotInterestedIcon from '@mui/icons-material/NotInterested';



export function BasicStepper({ activeStep, step_lst, time_lst = null }) {

  return (
    <Box sx={{ width: '100%', marginTop: '100px', ml: "50px" }}>
      <Stepper activeStep={activeStep+1} alternativeLabel>
        {time_lst ? (
          step_lst.map((label, index) => (
            <Step onClick={() => console.log('click')} key={label}>
              <StepLabel>{label}<br/>{time_lst[index]}</StepLabel>
            </Step>
          ))
        ) : (
          step_lst.map((label) => (
            <Step onClick={() => console.log('click')} key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))
        )}
      </Stepper>
    </Box>
  );
}



export  function VerticalLinearStepper({ activeStep, step_lst, time_lst, metadata }) {
  return (
    <Box >
      <Stepper activeStep={activeStep+1} orientation="vertical">
        {time_lst && activeStep < 4 ? (
          step_lst.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}<br/>{time_lst[index]}</StepLabel>
              {metadata[index] && <DisplayMetadata metadata={metadata[index]}/>}
            </Step>
          ))
        ) : <NotInterestedIcon sx = {{color: "red", fontSize: "large"}} />}
      </Stepper>
    </Box>
  );
}


const DisplayMetadata = ({metadata}) => {
  const [checked, setchecked] = useState(false)
  const note =  metadata.note ? metadata.note: null
  const images = metadata.images ? metadata.images: null
  const devices = metadata.devices ? metadata.devices:null

  const handleChecked = () => {
    setchecked((prev) => !prev);
  };

  return (
    <>
        <Button size='small' onClick={handleChecked}>Learn More</Button>
        <Collapse in = {checked}>
            <div>
            <Stack direction="row">
                {note && (
                      <>
                          <Typography sx = {{fontStyle: "italic", fontWeight: "bold", mr: 2}} variant = "caption">{note.user}:</Typography>
                          <Typography fontSize={13}>{note.caption}</Typography>
                      </>
                )}
            </Stack>
              {devices && (
                <ul>
                  {Object.keys(devices)
                    .filter(tool => devices[tool] !== null)
                    .map(tool => (
                      <li key={tool}>
                        {tool}: {devices[tool]}
                      </li>
                    ))}
                </ul>
              )}
              {images && (
              <ImageList sx={{ width: 250, mt: 5 }} cols={3}>
                  {images.map((item, index) => (
                      <ImageListItem key={index} >
                      <img
                          src={item}
                          alt={index}
                          loading="lazy"
                          style={{objectFit: "contain"}}
                      />
                      </ImageListItem>
                  ))}
              </ImageList>
              )}
            </div>
          </Collapse>
    </>
  )
}